module.exports = __webpack_public_path__ + "img/authors.31028c81.png";